"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSaveSearchDialogState = void 0;
var SaveSearchPageState_init_1 = require("@/pages/savesearch/states/SaveSearchPageState.init");
var SaveSearchDialogTranslate_init_1 = require("@/pages/search/states/SaveSearchDialogTranslate.init");
var HfilterState_init_1 = require("@/pages/search/states/HfilterState.init");
exports.defaultSaveSearchDialogState = {
    t: SaveSearchDialogTranslate_init_1.defaultSaveSearchDialogTranslate,
    isDim: false,
    isActive: false,
    isLoading: false,
    currentFilter: HfilterState_init_1.defaultHfilterState,
    customName: 'Custom Search',
    currentSearchId: 0,
    currentNotificationSettings: SaveSearchPageState_init_1.defaultNotificationSettings,
    saveNewEnabled: true,
};
